import {
  GET_IN_REPAIR_INVENTORIES_TYPE,
  GET_INREPAIR_INVENTORY_SUBROWS_TYPE,
  GET_INV_UPDATE_TIME_TYPE,
  GET_INVENTORIES_COUNTRY_NAME_TOTAL_QTY_GRAPH_TYPE,
  GET_INVENTORIES_FILTER_TYPE,
  GET_INVENTORIES_LIST_TYPE,
  GET_INVENTORIES_PART_TYPE_TOTAL_QTY_GARPH_TYPE,
  GET_INVENTORIES_RR_LIST_TYPE,
  GET_INVENTORIES_TEARDOWN_LIST_TYPE,
  GET_INVENTORY_PART_CLASS_TOTAL_QTY_GRAPH_TYPE,
  GET_INVENTORY_SUBROWS_TYPE,
  GET_INVENTORY_TIER_GRAPH_COUNT_GRAPH_TYPE,
  GET_RO_INVENTORIES_TYPE,
  GET_REPAIR_ORDER_RAG_DETAIL_TYPE,
  GET_REPAIR_ORDER_RAG_LISTING_TYPE,
  GET_REPAIR_ORDER_RAG_PRIORITY_VIEW_LISTING_TYPE,
  GET_REPAIR_ORDER_RAG_PRIORITY_VIEW_SUMMARY_TYPE,
  GET_REPAIR_ORDER_RVE_SNAPSHOT_CHART_TYPE,
  GET_REPAIR_ORDER_RVE_SNAPSHOT_LISTING_TYPE,
  GET_REPAIR_ORDER_RVE_SNAPSHOT_SUMMARY_TYPE,
  GET_REPAIR_ORDER_VENDOR_SCORECARD_GRAPH_TYPE,
  GET_REPAIR_ORDER_VENDOR_SCORECARD_LISTING_TYPE,
  GET_REPAIR_ORDER_VENDOR_SCORECARD_RAG_GRAPH_TYPE,
  GET_REPAIR_ORDER_ANALYTICS_DELAY_ATTRIBUTION_GRAPH_TYPE,
  GET_REPAIR_ORDER_ANALYTICS_PHASE_VOLUME_GRAPH_TYPE,
  GET_REPAIR_ORDER_ANALYTICS_PRIORITY_TIER_GRAPH_TYPE,
  GET_REPAIR_ORDER_ANALYTICS_RAG_DISTRIBUTION_GRAPH_TYPE,
  GET_REPAIR_ORDER_ANALYTICS_WORKSTREAM_SPLIT_GRAPH_TYPE,
  GET_REPAIR_ORDER_DATA_QUALITY_LISTING_TYPE,
  GET_REPAIR_ORDER_DATA_QUALITY_SUMMARY_TYPE,
  GET_REPAIR_ORDER_RAG_SUBROWS_TYPE,
  GET_REPAIR_ORDER_RAG_SUMMARY_TYPE,
  GET_RO_INVENTORY_SUBROWS_TYPE,
  GET_SLOW_MOVEING_INVENTORIES_TYPE,
  GET_SLOWMOVING_INVENTORY_SUBROWS_TYPE,
  GET_STOCK_SUMMARY_INVENTORY_DETAILS_TYPE,
  GET_UNDER_STOCK_INVENTORIES_TYPE,
  GET_UNDERSTOCK_INVENTORY_SUBROWS_TYPE,
} from "../../../constant/asynActionsType";
import { createAppAsyncThunk } from "../../../utils/createAppAsyncThunk";
import {
  GetInRepairInventoriesService,
  GetInRepairInventorySubrowsService,
  GetInventoriesFilterService,
  GetInventoriesRRService,
  GetInventoriesService,
  GetInventoryCountryNameTotalQtyGraphService,
  GetInventoryPartClassTotalQtyGraphService,
  GetInventoryPartTypeTotalQtyGraphService,
  GetInventoryStockSummaryDetailsService,
  GetInventorySubrowsService,
  GetInventoryTeardownService,
  GetInventoryTierGraphCountGraphService,
  GetINVUpdateTimeService,
  GetROInventoriesService,
  GetRepairOrderRAGDetailService,
  GetRepairOrderRAGListingService,
  GetRepairOrderRAGPriorityViewListingService,
  GetRepairOrderRAGPriorityViewSummaryService,
  GetRepairOrderRveSnapshotChartService,
  GetRepairOrderRveSnapshotListingService,
  GetRepairOrderRveSnapshotSummaryService,
  GetRepairOrderVendorScorecardGraphService,
  GetRepairOrderVendorScorecardListingService,
  GetRepairOrderVendorScorecardRagGraphService,
  GetRepairOrderAnalyticsDelayAttributionGraphService,
  GetRepairOrderAnalyticsPhaseVolumeGraphService,
  GetRepairOrderAnalyticsPriorityTierGraphService,
  GetRepairOrderAnalyticsRagDistributionGraphService,
  GetRepairOrderAnalyticsWorkstreamSplitGraphService,
  GetRepairOrderDataQualityListingService,
  GetRepairOrderDataQualitySummaryService,
  GetRepairOrderRAGSummaryService,
  GetROInventorySubrowsService,
  GetSlowMoveingInventoriesService,
  GetSlowMoveingInventorySubrowsService,
  GetUnderStockInventoriesService,
  GetUnderStockInventorySubrowsService,
} from "./InventoriesServices";

// listing

export const getInventories = createAppAsyncThunk(
  GET_INVENTORIES_LIST_TYPE,
  GetInventoriesService,
  {
    errorMessage: {
      show: true,
    },
  }
);

export const getInventoriesFilter = createAppAsyncThunk(
  GET_INVENTORIES_FILTER_TYPE,
  GetInventoriesFilterService
);

export const getInRepairInventoriesList = createAppAsyncThunk(
  GET_IN_REPAIR_INVENTORIES_TYPE,
  GetInRepairInventoriesService
);

export const getUnderStockInventoriesList = createAppAsyncThunk(
  GET_UNDER_STOCK_INVENTORIES_TYPE,
  GetUnderStockInventoriesService
);

export const getSlowMoveingInventoriesList = createAppAsyncThunk(
  GET_SLOW_MOVEING_INVENTORIES_TYPE,
  GetSlowMoveingInventoriesService
);

export const getStockSummaryInventoryDetails = createAppAsyncThunk(
  GET_STOCK_SUMMARY_INVENTORY_DETAILS_TYPE,
  GetInventoryStockSummaryDetailsService
);

export const getInventoryTeardownInventoryList = createAppAsyncThunk(
  GET_INVENTORIES_TEARDOWN_LIST_TYPE,
  GetInventoryTeardownService
);

// Graph

export const getInventoryCountryNameTotalQtyGraph = createAppAsyncThunk(
  GET_INVENTORIES_COUNTRY_NAME_TOTAL_QTY_GRAPH_TYPE,
  GetInventoryCountryNameTotalQtyGraphService
);

export const getInventoryPartClassTotalQtyGraph = createAppAsyncThunk(
  GET_INVENTORY_PART_CLASS_TOTAL_QTY_GRAPH_TYPE,
  GetInventoryPartClassTotalQtyGraphService
);

export const getInventoryTierGraphCountGraph = createAppAsyncThunk(
  GET_INVENTORY_TIER_GRAPH_COUNT_GRAPH_TYPE,
  GetInventoryTierGraphCountGraphService
);

export const getInventoryPartTypeTotalQtyGraph = createAppAsyncThunk(
  GET_INVENTORIES_PART_TYPE_TOTAL_QTY_GARPH_TYPE,
  GetInventoryPartTypeTotalQtyGraphService
);

export const getInventorySubrows = createAppAsyncThunk(
  GET_INVENTORY_SUBROWS_TYPE,
  GetInventorySubrowsService,
  {
    errorMessage: {
      show: true,
    },
  }
);

export const getUnderStockInventorySubrows = createAppAsyncThunk(
  GET_UNDERSTOCK_INVENTORY_SUBROWS_TYPE,
  GetUnderStockInventorySubrowsService,
  {
    errorMessage: {
      show: true,
    },
  }
);

export const getInRepairInventorySubrows = createAppAsyncThunk(
  GET_INREPAIR_INVENTORY_SUBROWS_TYPE,
  GetInRepairInventorySubrowsService,
  {
    errorMessage: {
      show: true,
    },
  }
);

export const getROInventorySubrows = createAppAsyncThunk(
  GET_RO_INVENTORY_SUBROWS_TYPE,
  GetROInventorySubrowsService,
  {
    errorMessage: {
      show: true,
    },
  }
);

export const getSlowMoveingInventorySubrows = createAppAsyncThunk(
  GET_SLOWMOVING_INVENTORY_SUBROWS_TYPE,
  GetSlowMoveingInventorySubrowsService,
  {
    errorMessage: {
      show: true,
    },
  }
);

export const getInventoriesRR = createAppAsyncThunk(
  GET_INVENTORIES_RR_LIST_TYPE,
  GetInventoriesRRService,
  {
    errorMessage: {
      show: true,
    },
  }
);

export const getROInventoriesList = createAppAsyncThunk(
  GET_RO_INVENTORIES_TYPE,
  GetROInventoriesService
);

export const getRepairOrderRAGListing = createAppAsyncThunk(
  GET_REPAIR_ORDER_RAG_LISTING_TYPE,
  GetRepairOrderRAGListingService
);

export const getRepairOrderRAGSummary = createAppAsyncThunk(
  GET_REPAIR_ORDER_RAG_SUMMARY_TYPE,
  GetRepairOrderRAGSummaryService
);

export const getRepairOrderRAGPriorityViewListing = createAppAsyncThunk(
  GET_REPAIR_ORDER_RAG_PRIORITY_VIEW_LISTING_TYPE,
  GetRepairOrderRAGPriorityViewListingService
);

export const getRepairOrderRAGPriorityViewSummary = createAppAsyncThunk(
  GET_REPAIR_ORDER_RAG_PRIORITY_VIEW_SUMMARY_TYPE,
  GetRepairOrderRAGPriorityViewSummaryService
);

export const getRepairOrderRveSnapshotSummary = createAppAsyncThunk(
  GET_REPAIR_ORDER_RVE_SNAPSHOT_SUMMARY_TYPE,
  GetRepairOrderRveSnapshotSummaryService
);

export const getRepairOrderRveSnapshotListing = createAppAsyncThunk(
  GET_REPAIR_ORDER_RVE_SNAPSHOT_LISTING_TYPE,
  GetRepairOrderRveSnapshotListingService
);

export const getRepairOrderRveSnapshotChart = createAppAsyncThunk(
  GET_REPAIR_ORDER_RVE_SNAPSHOT_CHART_TYPE,
  GetRepairOrderRveSnapshotChartService
);

export const getRepairOrderVendorScorecardListing = createAppAsyncThunk(
  GET_REPAIR_ORDER_VENDOR_SCORECARD_LISTING_TYPE,
  GetRepairOrderVendorScorecardListingService
);

export const getRepairOrderVendorScorecardGraph = createAppAsyncThunk(
  GET_REPAIR_ORDER_VENDOR_SCORECARD_GRAPH_TYPE,
  GetRepairOrderVendorScorecardGraphService
);

export const getRepairOrderVendorScorecardRagGraph = createAppAsyncThunk(
  GET_REPAIR_ORDER_VENDOR_SCORECARD_RAG_GRAPH_TYPE,
  GetRepairOrderVendorScorecardRagGraphService
);

export const getRepairOrderAnalyticsPriorityTierGraph = createAppAsyncThunk(
  GET_REPAIR_ORDER_ANALYTICS_PRIORITY_TIER_GRAPH_TYPE,
  GetRepairOrderAnalyticsPriorityTierGraphService
);

export const getRepairOrderAnalyticsWorkstreamSplitGraph = createAppAsyncThunk(
  GET_REPAIR_ORDER_ANALYTICS_WORKSTREAM_SPLIT_GRAPH_TYPE,
  GetRepairOrderAnalyticsWorkstreamSplitGraphService
);

export const getRepairOrderAnalyticsRagDistributionGraph = createAppAsyncThunk(
  GET_REPAIR_ORDER_ANALYTICS_RAG_DISTRIBUTION_GRAPH_TYPE,
  GetRepairOrderAnalyticsRagDistributionGraphService
);

export const getRepairOrderAnalyticsPhaseVolumeGraph = createAppAsyncThunk(
  GET_REPAIR_ORDER_ANALYTICS_PHASE_VOLUME_GRAPH_TYPE,
  GetRepairOrderAnalyticsPhaseVolumeGraphService
);

export const getRepairOrderAnalyticsDelayAttributionGraph = createAppAsyncThunk(
  GET_REPAIR_ORDER_ANALYTICS_DELAY_ATTRIBUTION_GRAPH_TYPE,
  GetRepairOrderAnalyticsDelayAttributionGraphService
);

export const getRepairOrderDataQualitySummary = createAppAsyncThunk(
  GET_REPAIR_ORDER_DATA_QUALITY_SUMMARY_TYPE,
  GetRepairOrderDataQualitySummaryService
);

export const getRepairOrderDataQualityListing = createAppAsyncThunk(
  GET_REPAIR_ORDER_DATA_QUALITY_LISTING_TYPE,
  GetRepairOrderDataQualityListingService
);

export const getRepairOrderRAGSubrows = createAppAsyncThunk(
  GET_REPAIR_ORDER_RAG_SUBROWS_TYPE,
  GetRepairOrderRAGListingService,
  {
    errorMessage: {
      show: true,
    },
  }
);

export const getRepairOrderRAGDetail = createAppAsyncThunk(
  GET_REPAIR_ORDER_RAG_DETAIL_TYPE,
  GetRepairOrderRAGDetailService,
  {
    errorMessage: {
      show: true,
    },
  }
);

export const getINVUpdateTime = createAppAsyncThunk(
  GET_INV_UPDATE_TIME_TYPE,
  GetINVUpdateTimeService
);
